"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
function mapPrimaryPax(input) {
    return {
        id: input.id,
        firstName: input.firstName,
        lastName: input.lastName,
        sex: input.sex,
        street: input.street,
        birthday: input.birthday,
        zipcode: input.zipCode,
        city: input.city,
        country: input.postalCountryCode,
        email: input.email,
        phone: input.phone,
        nationality: input.nationalityCode,
        bahnCard: input.bahnCard,
        erpId: input.erpId,
    };
}
function mapFellowTravellers(input) {
    var fellowPaxes = lodash_1.filter(input, function (pax) {
        return pax.isBuyer !== true;
    });
    return lodash_1.map(fellowPaxes, function (fellowPax) {
        return {
            id: fellowPax.id,
            firstName: fellowPax.firstName,
            lastName: fellowPax.lastName,
            sex: fellowPax.sex,
            birthday: fellowPax.birthday,
            nationality: fellowPax.nationalityCode,
            bahnCard: fellowPax.bahnCard,
            erpId: fellowPax.erpId,
        };
    });
}
function mapCruiseService(input) {
    var cruises = lodash_1.filter(input, (function (srv) {
        return srv.type === 'CRU';
    }));
    return lodash_1.map(cruises, function (cruise) {
        var cabin = cruise.cabinNumber
            ? lodash_1.toString(cruise.cabinNumber)
            : undefined;
        return {
            id: cruise.id,
            paxIDs: cruise.paxIds,
            cabin: cabin,
            cabinCategory: cruise.cabinCategory,
        };
    });
}
function mapFlightService(input) {
    var flights = lodash_1.filter(input, (function (srv) {
        return srv.type === 'AIR';
    }));
    return lodash_1.map(flights, function (flight) {
        return {
            id: flight.code,
            paxIDs: flight.paxIds,
            direction: flight.direction,
            //price: flight.price,
            class: flight.category,
        };
    });
}
function mapTrainService(input) {
    var trains = lodash_1.filter(input, (function (srv) {
        return srv.type === 'RIT';
    }));
    return lodash_1.map(trains, function (train) {
        return {
            id: train.code,
            paxIDs: train.paxIds,
            startDate: train.startDate,
            endDate: train.endDate,
            class: train.category,
            direction: train.direction,
        };
    });
}
function mapRailAndFlightService(input) {
    var trains = lodash_1.filter(input, (function (srv) {
        return srv.type === 'RNF';
    }));
    return lodash_1.map(trains, function (train) {
        return {
            id: train.code,
            paxIDs: train.paxIds,
            startDate: train.startDate,
            endDate: train.endDate,
            class: train.category,
            direction: train.direction,
        };
    });
}
function mapInsuranceService(input) {
    var insurances = lodash_1.filter(input, (function (srv) {
        return srv.type === 'INS';
    }));
    return lodash_1.map(insurances, function (insurance) {
        return {
            id: insurance.code,
            paxIDs: insurance.paxIds,
        };
    });
}
exports.convertBookingRequest = function (input) {
    var priceModel = input.priceModel;
    var buyer = mapPrimaryPax(input.buyer);
    var fellowTravellers = mapFellowTravellers(input.paxe);
    var insurances = mapInsuranceService(input.services);
    var flights = mapFlightService(input.services);
    var cruises = mapCruiseService(input.services);
    var trains = mapTrainService(input.services);
    var railAndFlights = mapRailAndFlightService(input.services);
    var optionBooking = input.confirmations.optionBooking;
    var estimatedTotalPrice = input.estimatedTotalPrice;
    var tradingConditionsAccepted = input.confirmations.tradingConditionsAccepted;
    var bookingConditionsAccepted = input.confirmations.bookingConditionsAccepted;
    var privacyPolicyAccepted = input.confirmations.privacyPolicyAccepted;
    var newsletterAccepted = input.confirmations.newsletterAccepted;
    var privacyPolicyExtendedAccepted = input.confirmations.privacyPolicyExtendeAccepted;
    var agencyID = input.affiliate.agencyId;
    var midofficeReference = input.affiliate.midofficeReference;
    return {
        priceModel: priceModel,
        buyer: buyer,
        fellowTravellers: fellowTravellers,
        flights: flights,
        insurances: insurances,
        cruises: cruises,
        trains: trains,
        railAndFlights: railAndFlights,
        optionBooking: optionBooking,
        estimatedTotalPrice: estimatedTotalPrice,
        tradingConditionsAccepted: tradingConditionsAccepted,
        bookingConditionsAccepted: bookingConditionsAccepted,
        privacyPolicyAccepted: privacyPolicyAccepted,
        newsletterAccepted: newsletterAccepted,
        agencyID: agencyID,
        privacyPolicyExtendedAccepted: privacyPolicyExtendedAccepted,
        //@ts-ignore
        midofficeReference: midofficeReference
    };
};
exports.extendToExpinetBookRequest = function (oldBookRequest, agentData) {
    var isExpinetOrigin = true;
    var agent = !!oldBookRequest && !!oldBookRequest.agencyID ? agentData : undefined;
    return __assign({ agent: agent,
        isExpinetOrigin: isExpinetOrigin }, oldBookRequest);
};
//# sourceMappingURL=mapBooking.js.map